import SubcategoryPage from '@/components/template/SubcategoryPage';

const Cronografo = () => {
  const products = [
    {
      title: "Cronografo Model 1",
      imageSrc: "https://images.unsplash.com/photo-1589798312990-ea8f06163835?auto=format&fit=crop&q=80",
      url: "/ogledala/cronografo/model-1"
    },
    {
      title: "Cronografo Model 2",
      imageSrc: "https://images.unsplash.com/photo-1553192225-2414fc01533e?auto=format&fit=crop&q=80",
      url: "/ogledala/cronografo/model-2"
    },
    {
      title: "Cronografo Model 3",
      imageSrc: "https://images.unsplash.com/photo-1596079890701-dd42edf0b7d4?auto=format&fit=crop&q=80",
      url: "/ogledala/cronografo/model-3"
    },
    {
      title: "Cronografo Model 4",
      imageSrc: "https://images.unsplash.com/photo-1616046386594-c152babc9e15?auto=format&fit=crop&q=80",
      url: "/ogledala/cronografo/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Cronografo"
      description="Ogledala z vgrajeno uro za elegantno kombinacijo funkcionalnosti. Italijansko oblikovanje, ki združuje tradicijo z inovacijo."
      heroImage="https://images.unsplash.com/photo-1589798312990-ea8f06163835?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Cronografo;